<template>
    <div :class="className()">
      <div>
        <img src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7">
        <div @click="click">
          <div/>
          <div/>
          <div/>
          <div/>
        </div>
      </div>
      <div class="slot"><slot></slot></div>
    </div>
</template>

<script>
export default {
  props: {
    disabled: Boolean,
    initial: Boolean,
    onClick: Function,
    value: String
  },
  mounted () {
    if (typeof this.initial !== 'undefined') this.toggle(this.initial)
  },
  data () {
    return {
      on: false
    }
  },
  watch: {
    disabled (v) {
      if (v && this.on) this.toggle(false)
    }
  },
  methods: {
    className () {
      return 'toggle' + (this.on ? ' on' : '') + (this.disabled ? ' disabled' : '')
    },
    click () {
      if (this.disabled) return
      if (this.onClick) {
        this.onClick(!this.on)
        return
      }
      this.toggle(!this.on)
    },
    toggle (on) {
      if (this.value) {
        this.$emit('update', {
          on: on,
          value: this.value
        })
      }
      this.on = on
    }
  }
}
</script>

<style scoped>

.toggle {
  align-items: center;
  display: flex;
  flex-direction: row;
}

.toggle.disabled {
  opacity: 0.3;
}

.toggle > div:first-child {
  height: 100%;
  position: relative;
}

.toggle > div:first-child > img {
  height: 215%; /* 200% + 15% for margin right. otherwise setting margin-right the regular way doesn't expand the toggle size :( */
}

.toggle > div:first-child > div {
  bottom: 0;
  cursor: pointer;
  left: 0;
  margin-right: 15%;
  padding: 4%;
  position: absolute;
  right: 0;
  top: 0;
}

.toggle.disabled > div:first-child > div {
  cursor: default;
}

.toggle > div:first-child > div > div:first-child {
  border-radius: 50%;
  left: 0;
}

.toggle > div:first-child > div > div:nth-child(2) {
  left: 25%;
}

.toggle > div:first-child > div > div:nth-child(3) {
  border-radius: 50%;
  right: 0;
}

.toggle > div:first-child > div > div:nth-child(4) {
  background-color: white;
  border-radius: 50%;
  height: 100%;
  left: 0;
  position: relative;
  top: 0;
  transition: .4s;
  width: 50%;
}

.toggle > div:first-child > div > div:nth-child(1),
.toggle > div:first-child > div > div:nth-child(2),
.toggle > div:first-child > div > div:nth-child(3) {
  background-color: #666666;
  height: 100%;
  position: absolute;
  top: 0;
  transition: .4s;
  width: 50%;
}

.toggle.on > div:first-child > div > div:nth-child(1),
.toggle.on > div:first-child > div > div:nth-child(2),
.toggle.on > div:first-child > div > div:nth-child(3) {
  background-color: #ff6e20;
}

.toggle.on > div:first-child > div > div:nth-child(4) {
  -webkit-transform: translateX(100%);
  transform: translateX(100%);
}

.toggle > div:last-child {
  position: relative;
  top: 3%;
}

</style>
